/* ES: Popularity badges + side pop-out (Oct 2026 test). Loaded by snippets/es-pop-head.liquid only when at least
   one of the two switches is on. Everything here fails silently: no data, no worker, or any error = nothing
   shown and nothing broken.
   Card rules (Oct 18): grid cards only show the hottest badges (right now / selling quickly / today / this week),
   and each grid shows at most 1 badge per 4 cards (carousels at most 2), strongest first. The slower badges
   (last week / month / year / all-time) only show on that product's own page. */
(function () {
  var P = window.esPop;
  if (!P || window.esPopBound) return;
  window.esPopBound = true;
  var SHOWN = P.g === 'shown';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var LABEL = { now: 'Popular right now', today: 'Popular today', fast: 'Selling quickly', week: 'Popular this week', lastweek: 'Popular last week', month: 'Popular this month', year: 'Popular this year', alltime: 'All-time favorite' };
  var CARD_RANK = ['now', 'fast', 'today', 'week'];   // badges allowed on grid cards, strongest first
  var PER_CARDS = 4;                                  // 1 badge per 4 cards in a grid
  var CAROUSEL_MAX = 2;                               // never more than 2 in a carousel
  var FLAME = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2c1 3.5 4.5 5.3 4.5 9.6A4.5 4.5 0 0 1 12 16a4.5 4.5 0 0 1-4.5-4.4c0-1.6.7-2.8 1.6-3.7.2 1.4 1 2.3 2 2.6C10.6 7.6 11.2 4.4 12 2z" fill="#D81B60"/><path d="M6 14.5A6 6 0 0 0 18 15c0 3.6-2.7 7-6 7s-6-3.4-6-7.5z" fill="#ff8fb3"/></svg>';
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function rid() { return Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var vid = ls('es_pop_vid'); if (!vid) { vid = rid(); ls('es_pop_vid', vid); }
  var sid = ss('es_pop_sid'), newVisit = !sid; if (!sid) { sid = rid(); ss('es_pop_sid', sid); }
  var BOT = navigator.webdriver || /bot|crawl|spider|slurp|headless|lighthouse|pingdom|preview/i.test(navigator.userAgent || '');
  var isCart = P.page === 'cart' || /^\/(cart|checkouts?)(\/|$)/.test(location.pathname);

  /* ---- Tracking pings (one tiny beacon each, no personal data) ---- */
  var queue = [], qt;
  function ping(t, extra) {
    if (!P.api || BOT) return;
    var ev = { t: t, g: P.g, p: P.page };
    if (extra) for (var k in extra) ev[k] = extra[k];
    queue.push(ev);
    clearTimeout(qt); qt = setTimeout(flush, 800);
  }
  function flush() {
    if (!queue.length || !P.api) return;
    var body = JSON.stringify({ v: vid, s: sid, ev: queue.splice(0, 40) });
    try { if (navigator.sendBeacon && navigator.sendBeacon(P.api.replace(/\/$/, '') + '/e', body)) return; } catch (e) {}
    try { fetch(P.api.replace(/\/$/, '') + '/e', { method: 'POST', body: body, keepalive: true, mode: 'no-cors' }); } catch (e) {}
  }
  document.addEventListener('visibilitychange', function () { if (document.hidden) flush(); });
  if (newVisit) ping('visit');
  if (P.page === 'product' && P.pid) ping('view', { pid: String(P.pid) });

  /* ---- Cart attributes: group once per visit, last clicked product on click. No visible cart change. ---- */
  function setAttr(attrs, keep) {
    try { return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }), keepalive: !!keep }); } catch (e) {}
  }
  function stampGroup() { if (ss('es_pop_ca') === P.g) return; ss('es_pop_ca', P.g); setAttr({ _es_pop_group: P.g }); }
  window.addEventListener('load', function () { setTimeout(stampGroup, 2500); });
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('[data-es-pop-h]');
    if (!a) return;
    var h = a.getAttribute('data-es-pop-h'), kind = a.getAttribute('data-es-pop-k') || 'badge';
    ss('es_pop_ca', P.g);
    setAttr({ _es_pop_group: P.g, _es_pop_clicked: h }, true);
    ping(kind === 'pop' ? 'pop_click' : 'click', { h: h, b: a.getAttribute('data-es-pop-b') || '' });
    flush();
  }, true);

  /* ---- Card badges (sit on top of the card picture, so nothing moves) ---- */
  var nowSec = Math.floor(Date.now() / 1000);
  function badgeFor(h) { var e = P.map && P.map[h]; return e && LABEL[e[0]] && e[1] > nowSec ? e[0] : null; }
  function cardBadge(h) { var b = badgeFor(h); return b && CARD_RANK.indexOf(b) > -1 ? b : null; }
  function handleOf(href) { var m = /\/products\/([^/?#]+)/.exec(href || ''); return m ? decodeURIComponent(m[1]) : null; }
  function groupOf(w) { return w.closest('ul') || w.closest('.grid') || w.parentElement || document.body; }
  function isCarousel(g) { return !!(g.closest('slider-component') || /(^|\s)slider(\s|$|--)/.test(g.className || '') || g.closest('.swiper')); }
  var counted = typeof WeakSet === 'function' ? new WeakSet() : null, eligN = 0, impObs = null;
  if (SHOWN && 'IntersectionObserver' in window) {
    impObs = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { impObs.unobserve(en.target); ping('imp', { h: en.target.getAttribute('data-es-pop-h') || P.handle, b: en.target.getAttribute('data-es-pop-b') }); } });
    }, { threshold: 0.6 });
  }
  function addBadge(c) {
    var own = P.page === 'product' && c.h === P.handle;
    var el = document.createElement(own ? 'span' : 'a');
    el.className = 'es-pop es-pop-b es-pop-b--card';
    if (!own) { el.href = c.link.getAttribute('href'); el.setAttribute('data-es-pop-k', 'badge'); }
    el.setAttribute('data-es-pop-h', c.h);
    el.setAttribute('data-es-pop-b', c.b);
    el.innerHTML = FLAME + '<span>' + esc(LABEL[c.b]) + '</span>';
    /* On .card (not .card__inner) so it sits above the card's own full-card link and records the click */
    el.style.zIndex = '5';
    c.inner.appendChild(el);
    if (impObs) impObs.observe(el);
  }
  /* Re-checks every grid on the page: picks the strongest badged cards up to the grid's cap and removes any extra.
     Both test groups make the same picks, so "eligible" counts are comparable; only "shown" visitors see them. */
  function scanCards() {
    if (!P.badges) return 0;
    var wraps = document.querySelectorAll('.card-wrapper'), groups = [], gIdx = [], added = 0;
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i], g = groupOf(w), k = gIdx.indexOf(g);
      if (k < 0) { k = gIdx.length; gIdx.push(g); groups.push({ el: g, n: 0, cands: [] }); }
      var grp = groups[k];
      grp.n++;
      var link = w.querySelector('a[href*="/products/"]');
      var h = link && handleOf(link.getAttribute('href'));
      var b = h && cardBadge(h);
      var inner = w.querySelector('.card') || w.querySelector('.card__inner');
      var soldBadge = w.querySelector('.card__badge .badge');
      if (soldBadge && (soldBadge.textContent || '').toLowerCase().indexOf('sold') > -1) b = null;
      var have = w.querySelector('.es-pop-b--card');
      if (!b || !inner) { if (have) have.remove(); continue; }
      grp.cands.push({ w: w, h: h, b: b, link: link, inner: inner, have: have, pos: grp.cands.length });
    }
    groups.forEach(function (grp) {
      var cap = Math.floor(grp.n / PER_CARDS);
      if (isCarousel(grp.el)) cap = Math.min(cap, CAROUSEL_MAX);
      grp.cands.sort(function (a, c) { return CARD_RANK.indexOf(a.b) - CARD_RANK.indexOf(c.b) || a.pos - c.pos; });
      grp.cands.forEach(function (c, idx) {
        var keep = idx < cap;
        if (!keep) { if (c.have) c.have.remove(); return; }
        if (counted ? !counted.has(c.w) : !c.w.dataset.esPopCounted) {
          if (counted) counted.add(c.w); else c.w.dataset.esPopCounted = '1';
          eligN++; added++;
        }
        if (SHOWN && !c.have) addBadge(c);
      });
    });
    return added;
  }
  var pdpB = document.querySelector('[data-es-pop-pdp]');
  function startCards() {
    var n = scanCards();
    if (pdpB) { n++; eligN++; if (impObs && SHOWN) impObs.observe(pdpB); }
    if (n) ping('elig', { n: n });
    if ('MutationObserver' in window) {
      var mt, busy = false;
      new MutationObserver(function () {
        if (busy) return;
        clearTimeout(mt);
        mt = setTimeout(function () { busy = true; var more = scanCards(); setTimeout(function () { busy = false; }, 0); if (more) ping('elig', { n: more }); }, 250);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  /* ---- "Right now" (one cached call to the worker, 1.5 s limit, silent fail) ---- */
  function getNow(cb) {
    if (!P.api) return cb(null);
    var done = false, t = setTimeout(function () { if (!done) { done = true; cb(null); } }, 1500);
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    try {
      fetch(P.api.replace(/\/$/, '') + '/now', { signal: ctl ? ctl.signal : undefined, credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        if (done) return; done = true; clearTimeout(t); cb(j && j.now ? j : null);
      }).catch(function () { if (!done) { done = true; clearTimeout(t); cb(null); } });
    } catch (e) { if (!done) { done = true; clearTimeout(t); cb(null); } }
    setTimeout(function () { if (ctl && !done) try { ctl.abort(); } catch (e) {} }, 1600);
  }

  /* ---- Side pop-out: once per visit, close button, never in the bag/checkout, never over buy buttons ---- */
  var BUY = 'button[name="add"], .product-form__submit, .quick-add__submit, .es-sticky, .es-sticky__btn, [data-es-sbar-btn], .es-lp__sticky, .rn__sticky, [name="checkout"], .shopify-payment-button, .es-pair, cart-drawer.active, .drawer.active';
  function rectsHit(r) {
    var els = document.querySelectorAll(BUY);
    for (var i = 0; i < els.length; i++) {
      var b = els[i].getBoundingClientRect();
      if (!b.width || !b.height) continue;
      var st = getComputedStyle(els[i]); if (st.visibility === 'hidden' || st.display === 'none') continue;
      if (b.left < r.right + 6 && b.right > r.left - 6 && b.top < r.bottom + 6 && b.bottom > r.top - 6) return true;
    }
    return false;
  }
  /* Any open modal on screen (bag drawer, menu, quick view, the email sign-up pop-up): never stack on top of it */
  function modalOpen() {
    var els = document.querySelectorAll('[role="dialog"][aria-modal="true"]');
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (!r.width || !r.height || r.right <= 0 || r.left >= innerWidth || r.bottom <= 0 || r.top >= innerHeight) continue;
      var st = getComputedStyle(els[i]);
      if (st.visibility !== 'hidden' && st.display !== 'none' && Number(st.opacity) > 0.05) return true;
    }
    return false;
  }
  function bagOpen() { return !!document.querySelector('cart-drawer.active, .drawer.active, quick-add-modal[open], details[open] > .menu-drawer') || document.body.classList.contains('overflow-hidden') || modalOpen(); }
  function buildPop(item) {
    var box = document.createElement('div');
    box.className = 'es-po';
    box.setAttribute('role', 'complementary');
    box.setAttribute('aria-label', 'Popular product');
    box.innerHTML = '<a class="es-po__link" href="' + esc(item.u) + '" data-es-pop-h="' + esc(item.h) + '" data-es-pop-k="pop" data-es-pop-b="' + esc(item.b) + '">' +
      (item.i ? '<img class="es-po__img" src="' + esc(item.i) + '" alt="" width="48" height="48" loading="lazy">' : '') +
      '<span class="es-po__txt"><span class="es-po__lbl">🔥 ' + esc(LABEL[item.b] || '') + '</span><span class="es-po__name">' + esc(item.t) + '</span></span><span class="es-po__go" aria-hidden="true">→</span></a>' +
      '<button type="button" class="es-po__x" aria-label="Close">×</button>';
    var css = document.createElement('style');
    css.textContent = '.es-po{position:fixed;left:12px;z-index:60;display:flex;align-items:stretch;width:min(300px,calc(100vw - 24px));background:#fff;border-radius:14px;box-shadow:0 6px 24px rgba(26,26,26,.18),inset 0 0 0 1.5px #FBEEF2;transform:translateX(calc(-100% - 24px));transition:transform .45s cubic-bezier(.2,.8,.2,1);font-family:inherit}' +
      '.es-po.is-in{transform:none}.es-po__link{flex:1;min-width:0;display:flex;align-items:center;gap:10px;padding:10px 4px 10px 10px;color:#1A1A1A;text-decoration:none}' +
      '.es-po__img{flex-shrink:0;width:48px;height:48px;border-radius:10px;object-fit:cover;background:#FBEEF2}.es-po__txt{min-width:0;display:flex;flex-direction:column;gap:2px}' +
      '.es-po__lbl{font-family:"Montserrat Alternates",sans-serif;font-weight:700;font-size:12px;line-height:1.2;color:#D81B60}' +
      '.es-po__name{font-size:14px;font-weight:600;line-height:1.25;color:#1A1A1A;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
      '.es-po__go{flex-shrink:0;align-self:center;font-size:18px;color:#D81B60;padding-left:2px}.es-po__link:hover .es-po__name{text-decoration:underline}' +
      '.es-po__x{flex-shrink:0;width:36px;border:0;border-left:1px solid #FBEEF2;border-radius:0 14px 14px 0;background:transparent;color:#1A1A1A;font-size:20px;line-height:1;cursor:pointer}' +
      '.es-po__x:hover{background:#FBEEF2}@media (prefers-reduced-motion:reduce){.es-po{transition:none}}';
    document.head.appendChild(css);
    return box;
  }
  function place(box) {
    var hdr = document.querySelector('.section-header, header, .header-wrapper');
    var hb = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0;
    var slots = [{ bottom: '16px', top: 'auto' }, { top: Math.round(hb + 12) + 'px', bottom: 'auto' }, { top: '42%', bottom: 'auto' }];
    for (var i = 0; i < slots.length; i++) {
      box.style.top = slots[i].top; box.style.bottom = slots[i].bottom;
      var r = box.getBoundingClientRect(), vis = { left: 12, right: 12 + r.width, top: r.top, bottom: r.bottom };
      if (!rectsHit(vis)) return true;
    }
    return false;
  }
  function runPop() {
    if (!P.popout || isCart || ss('es_pop_po')) return;
    var feat = (P.feat || []).filter(function (f) { return f && f.u && f.h !== P.handle && f.x > nowSec && LABEL[f.b]; });
    getNow(function (j) {
      if (j && j.now) {
        var n = j.now.filter(function (x) { return x && x.h && x.h !== P.handle && x.u && x.t; })[0];
        if (n) feat.unshift({ b: 'now', t: n.t, u: n.u, h: n.h, i: n.i, x: nowSec + 600 });
        if (pdpB && P.pid && j.now.some(function (x) { return String(x.id) === String(P.pid); })) {
          var tx = pdpB.querySelector('[data-es-pop-txt]'); if (tx) { tx.textContent = "This one's popular right now"; pdpB.setAttribute('data-es-pop-pdp', 'now'); }
        }
      }
      var item = feat[0];
      if (!item) return;
      var fired = false, tries = 0;
      function attempt() {
        if (fired || ss('es_pop_po') || document.hidden || bagOpen()) return;
        fired = true;
        ss('es_pop_po', '1');
        if (!SHOWN) { ping('pop_elig', { h: item.h, b: item.b }); return; }
        var box = buildPop(item);
        box.style.visibility = 'hidden';
        document.body.appendChild(box);
        if (!place(box)) { box.remove(); fired = false; ss('es_pop_po', ''); if (++tries < 4) return; ss('es_pop_po', '1'); return; }
        box.style.visibility = '';
        void box.offsetWidth; setTimeout(function () { box.classList.add('is-in'); }, 30);
        ping('pop_imp', { h: item.h, b: item.b });
        var gone = false;
        function out(reason) {
          if (gone) return; gone = true;
          box.classList.remove('is-in');
          setTimeout(function () { box.remove(); }, 500);
          if (reason) ping('pop_' + reason, { h: item.h });
          window.removeEventListener('scroll', onScroll);
        }
        box.querySelector('.es-po__x').addEventListener('click', function () { out('close'); });
        var auto = setTimeout(function () { out('auto'); }, 12000);
        box.addEventListener('mouseenter', function () { clearTimeout(auto); });
        var sc;
        function onScroll() { clearTimeout(sc); sc = setTimeout(function () { var r = box.getBoundingClientRect(); if (rectsHit({ left: r.left, right: r.right, top: r.top, bottom: r.bottom }) || bagOpen()) out('cover'); }, 80); }
        window.addEventListener('scroll', onScroll, { passive: true });
        var iv = setInterval(function () { if (gone) { clearInterval(iv); return; } if (bagOpen()) out('cover'); }, 700);
      }
      var t0 = Date.now();
      function maybe() {
        if (fired) return;
        var sh = document.documentElement.scrollHeight - innerHeight;
        var depth = sh > 0 ? scrollY / sh : 1;
        if (Date.now() - t0 > 6000 && (depth > 0.25 || Date.now() - t0 > 12000)) attempt();
      }
      window.addEventListener('scroll', function () { setTimeout(maybe, 50); }, { passive: true });
      setTimeout(maybe, 6100); setTimeout(maybe, 12100); setTimeout(maybe, 20000); setTimeout(maybe, 30000);
    });
  }

  function start() { try { startCards(); } catch (e) {} try { runPop(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
